module.exports = __webpack_public_path__ + "static/img/img5-map.f178a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awards/img5-map.png
// module id = s80U
// module chunks = 1